import KustomerNoteCard from './KustomerNoteCard';

export default KustomerNoteCard;
